import AService from '@/services/AService'

const ENTITY_NAME = 'stakeholder';

export default class StakeholderService extends AService {
  /**
   * Récupère la liste des titulaires
   * @return {Promise<StakeholderDto[]>}
   */
  async getAll(){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}`);
    return response.data;
  }
  /**
   * Récupère la liste des titulaires
   * @param {StakeholderFilter} params Filtre de recherche
   * @return {Promise<Page<StakeholderDto>>} Page de titulaires
   */
  async fetchStakeholdersPagingAndSorting (filter) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`,  { params: filter })
    return response.data
  }

  /**
   * Récupère un titulaire
   * @param id Identifiant du titulaire
   * @return {Promise<StakeholderDto>} le titulaire
   */
  async fetchStakeholder(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async addStakeholder (data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data;
  }

  async addStakeholderByAgent (data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/agent`, data);
    return response.data;
  }

  async updateStakeholder(data) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data
  }

  async unlockStakeholder(id) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/unlock/${id}`);
    return response.data
  }

  async lockStakeholder(id) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/lock/${id}`);
    return response.data
  }
}
